/**
 * Amani Premium Product Page Docking & Interactivity Script
 */
let sizeChosenOnMobile = false;
let isInitialLoad = true; // Tracks first page load so we don't override Liquid-rendered availability

/**
 * Measure real visible viewport (window.innerHeight accounts for browser navbar)
 * and set the gallery height so that gallery + title/price + add-to-bag = full screen.
 */
function setMobileGalleryHeight() {
  if (window.innerWidth > 768) return;

  const realVH = window.innerHeight; // True visible area, excludes browser bars
  document.documentElement.style.setProperty('--real-vh', realVH + 'px');

  // Measure the actual heights of the elements below the gallery
  const header = document.querySelector('.header-wrapper, .amani-header-mobile, [data-section-type="header"]');
  const mobileProductHeader = document.querySelector('.mobile-product-header');
  const buyBox = document.getElementById('amaniProductBuyBox');

  let headerH = header ? header.offsetHeight : 60;
  let titleH = mobileProductHeader ? mobileProductHeader.offsetHeight : 40;

  // Measure only the buy-box-actions (the Add to Bag button area) since header is hidden on mobile
  let buyBoxH = 0;
  if (buyBox) {
    const actionsEl = buyBox.querySelector('.buy-box-actions');
    const buyBoxStyle = getComputedStyle(buyBox);
    const buyBoxPadding = parseFloat(buyBoxStyle.paddingTop) + parseFloat(buyBoxStyle.paddingBottom);
    buyBoxH = (actionsEl ? actionsEl.offsetHeight : 50) + buyBoxPadding;
  }

  const galleryH = realVH - headerH - titleH - buyBoxH;
  document.documentElement.style.setProperty('--mobile-gallery-height', Math.max(galleryH, 200) + 'px');
}

document.addEventListener("DOMContentLoaded", function () {
  // Set mobile gallery height on load
  setMobileGalleryHeight();
  window.addEventListener('resize', setMobileGalleryHeight, { passive: true });
  // Re-measure after orientation changes and delayed font/image loads
  window.addEventListener('orientationchange', function() {
    setTimeout(setMobileGalleryHeight, 200);
  });
  
  // --- 1. FLOATING TO RESTING DOCKING LOGIC ---
  const track = document.getElementById("buy-box-docking-track");
  const buyBox = document.getElementById("amaniProductBuyBox");

  if (track && buyBox) {
    function checkDocking() {
      const trackRect = track.getBoundingClientRect();
      const buyBoxHeight = buyBox.offsetHeight || 250;

      if (trackRect.width) {
        document.documentElement.style.setProperty('--track-width', trackRect.width + 'px');
      }

      // The floating buy box bottom offset is 0 as set in styles
      const floatingBoxTop = window.innerHeight - buyBoxHeight;

      // Only dock when the track top has scrolled up to meet the floating box top
      if (trackRect.top <= floatingBoxTop) {
        buyBox.classList.remove("is-floating");
        buyBox.classList.add("is-stuck");
      } else {
        buyBox.classList.add("is-floating");
        buyBox.classList.remove("is-stuck");
      }
    }

    window.addEventListener("scroll", checkDocking, { passive: true });
    window.addEventListener("resize", checkDocking, { passive: true });
    checkDocking(); // Execute initial check
  }

  // --- Listeners for other variant selectors (color, etc.) ---
  const otherSelects = document.querySelectorAll(".other-select-dropdown");
  otherSelects.forEach(select => {
    select.addEventListener("change", function() {
      updateVariantAndAvailability();
    });
  });

  // Run once on load to initialize variant ID / price — but skip availability re-rendering
  // because the Liquid template already renders the correct out-of-stock/notify-me state.
  updateVariantAndAvailability();
  isInitialLoad = false; // After first run, allow full dynamic updates

  // --- Size row event delegation (more reliable on real mobile than inline onclick) ---
  const sizesList = document.querySelector(".dropdown-sizes-list");
  if (sizesList) {
    function handleSizeTap(e) {
      const row = e.target.closest(".size-row-item");
      if (!row) return;
      
      const sizeVal = row.dataset.sizeValue || row.querySelector(".size-name")?.textContent?.trim();
      
      if (row.classList.contains("out-of-stock")) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeVal) {
          openNotifyModal(sizeVal);
        }
        return;
      }
      
      if (sizeVal) {
        e.preventDefault();
        selectShopifySize(sizeVal);
      }
    }
    sizesList.addEventListener("click", handleSizeTap);
  }

  // Intercept add to bag submission if size has not been selected
  const productForm = document.getElementById("amani-product-form");
  if (productForm) {
    productForm.addEventListener("submit", function(e) {
      const optionsEl = document.getElementById("amani-product-options");
      if (optionsEl) {
        const productOptions = JSON.parse(optionsEl.dataset.options);
        const sizeOptionIndex = productOptions.findIndex(opt => opt.toLowerCase().includes('size'));
        if (sizeOptionIndex !== -1 && !sizeChosenOnMobile) {
          e.preventDefault();
          e.stopPropagation();
          openSizeDropdown();
        }
      }
    });
  }
});

// --- 2. DOCKING BUY BOX DROPDOWN INTERACTIVITY ---

function openSizeDropdown() {
  const buyBox = document.getElementById("amaniProductBuyBox");
  if (buyBox) {
    buyBox.classList.add("size-dropdown-open");
  }
}

function closeSizeDropdown() {
  const buyBox = document.getElementById("amaniProductBuyBox");
  if (buyBox) {
    buyBox.classList.remove("size-dropdown-open");
  }
}

function selectDevFallbackSize(size) {
  sizeChosenOnMobile = true;
  const activeLabel = document.getElementById("buy-box-active-size-label");
  const devActiveLabel = document.getElementById("dev-active-size-text");
  
  if (activeLabel) activeLabel.textContent = size;
  if (devActiveLabel) devActiveLabel.textContent = size;
  
  const mobileActiveLabel = document.getElementById("mobile-active-size-label");
  if (mobileActiveLabel) mobileActiveLabel.textContent = size;
  
  // Highlight the selected element in mock UI list
  const mockRows = document.querySelectorAll(".dev-fallback-variants .size-row-item");
  mockRows.forEach(row => {
    const rowSize = row.querySelector(".size-name")?.textContent;
    if (rowSize === size) {
      row.classList.add("active");
    } else {
      row.classList.remove("active");
    }
  });

  // Enable the Add to My Bag button for development demonstration
  const productForm = document.getElementById("amani-product-form");
  if (productForm) {
    const addToBagBtn = productForm.querySelector(".add-to-bag-btn");
    if (addToBagBtn) {
      addToBagBtn.removeAttribute("disabled");
      const btnText = addToBagBtn.querySelector(".btn-text");
      if (btnText) btnText.textContent = "ADD TO MY BAG";
      addToBagBtn.style.opacity = "1";
      addToBagBtn.style.pointerEvents = "auto";
    }
  }
  
  closeSizeDropdown();
}

function selectShopifySize(selectedSize) {
  sizeChosenOnMobile = true;
  
  // Highlight active row in UI list using data attribute for reliable matching
  const realRows = document.querySelectorAll(".buy-box-dropdown-content .size-row-item");
  realRows.forEach(row => {
    if (row.dataset.sizeValue === selectedSize) {
      row.classList.add("active");
    } else {
      row.classList.remove("active");
    }
  });

  // Update hidden select element
  const hiddenSelect = document.querySelector(".hidden-size-select");
  if (hiddenSelect) {
    hiddenSelect.value = selectedSize;
  }

  // Call the unified update function
  updateVariantAndAvailability();

  closeSizeDropdown();
}

// --- 3. UNIFIED VARIANT & AVAILABILITY UPDATE ---
function updateVariantAndAvailability() {
  const variantJsonElement = document.getElementById("amani-product-variants-json");
  const optionsEl = document.getElementById("amani-product-options");
  if (!variantJsonElement || !optionsEl) return;

  const variants = JSON.parse(variantJsonElement.textContent);
  const productOptions = JSON.parse(optionsEl.dataset.options);
  
  // Find which option index is the Size option
  const sizeOptionIndex = productOptions.findIndex(opt => opt.toLowerCase().includes('size'));
  
  // If size is not chosen on mobile/desktop, ensure active class is removed from size rows
  if (!sizeChosenOnMobile && sizeOptionIndex !== -1) {
    const sizeRowItems = document.querySelectorAll(".buy-box-dropdown-content .size-row-item");
    sizeRowItems.forEach(row => row.classList.remove("active"));
  }

  // Get currently selected options
  let currentSelections = productOptions.map((optName, index) => {
    if (index === sizeOptionIndex) {
      if (!sizeChosenOnMobile) return null;
      const activeSizeEl = document.querySelector(".buy-box-dropdown-content .size-row-item.active .size-name");
      return activeSizeEl ? activeSizeEl.textContent.trim() : null;
    } else {
      const selectEl = Array.from(document.querySelectorAll(".other-select-dropdown")).find(sel => sel.name === `options[${optName}]`);
      return selectEl ? selectEl.value : null;
    }
  });

  // Update sizes stock indicators dynamically based on other selections.
  // Skip on initial page load — Liquid already renders the correct state server-side.
  if (sizeOptionIndex !== -1 && !isInitialLoad) {
    const sizeRowItems = document.querySelectorAll(".buy-box-dropdown-content .size-row-item");
    sizeRowItems.forEach(row => {
      const sizeVal = row.querySelector(".size-name").textContent.trim();
      
      // Check if there is any available variant with this size and other selected options (case-insensitive & trimmed)
      const isSizeAvailableForCurrentSelections = variants.some(variant => {
        const matchesOtherOptions = productOptions.every((optName, idx) => {
          const variantOptVal = (variant.options[idx] || "").trim().toLowerCase();
          if (idx === sizeOptionIndex) {
            return variantOptVal === sizeVal.trim().toLowerCase();
          } else {
            const currentSelectedVal = currentSelections[idx];
            return currentSelectedVal === null || variantOptVal === (currentSelectedVal || "").trim().toLowerCase();
          }
        });
        return matchesOtherOptions && variant.available;
      });

      // Update class and notify link dynamically
      if (isSizeAvailableForCurrentSelections) {
        row.classList.remove("out-of-stock");
        const notifyLink = row.querySelector(".notify-link");
        if (notifyLink) notifyLink.remove();
        row.dataset.available = "true";
      } else {
        row.classList.add("out-of-stock");
        row.dataset.available = "false";
        let notifyLink = row.querySelector(".notify-link");
        if (!notifyLink) {
          notifyLink = document.createElement("a");
          notifyLink.href = "#";
          notifyLink.className = "notify-link";
          notifyLink.textContent = "Notify me";
          notifyLink.addEventListener("click", function(ev) {
            ev.stopPropagation();
            ev.preventDefault();
            openNotifyModal(sizeVal);
          });
          row.insertBefore(notifyLink, row.firstChild);
        }
      }
    });
  }

  // Find the variant that matches all current selections (prefer available) (case-insensitive & trimmed)
  let matchedVariant = variants.find(variant => {
    return variant.available && productOptions.every((optName, idx) => {
      const variantOptVal = (variant.options[idx] || "").trim().toLowerCase();
      const currentSelectedVal = currentSelections[idx];
      return currentSelectedVal === null || variantOptVal === (currentSelectedVal || "").trim().toLowerCase();
    });
  });

  if (!matchedVariant) {
    matchedVariant = variants.find(variant => {
      return productOptions.every((optName, idx) => {
        const variantOptVal = (variant.options[idx] || "").trim().toLowerCase();
        const currentSelectedVal = currentSelections[idx];
        return currentSelectedVal === null || variantOptVal === (currentSelectedVal || "").trim().toLowerCase();
      });
    });
  }

  const productForm = document.getElementById("amani-product-form");
  const priceDisplay = document.querySelector(".buy-box-price");
  const mobilePriceDisplay = document.querySelector(".mobile-price");
  const buyBoxCompareDisplay = document.querySelector(".buy-box-compare-at-price");
  const mobileCompareDisplay = document.querySelector(".mobile-compare-at-price");
  const buyBoxDiscountDisplay = document.querySelector(".buy-box-price-discount");
  const mobileDiscountDisplay = document.querySelector(".mobile-price-discount");
  const hiddenVariantIdInput = document.getElementById("amani-selected-variant-id");
  const addToBagBtn = productForm ? productForm.querySelector(".add-to-bag-btn") : null;
  const btnText = addToBagBtn ? addToBagBtn.querySelector(".btn-text") : null;

  const currentSelectedSize = currentSelections[sizeOptionIndex];

  if (matchedVariant) {
    if (hiddenVariantIdInput) {
      hiddenVariantIdInput.value = matchedVariant.id;
    }

    if (priceDisplay) {
      const priceFormatted = (matchedVariant.price / 100).toFixed(2);
      priceDisplay.textContent = priceDisplay.textContent.replace(/[0-9.,\s₹]+/, '₹' + priceFormatted);
    }
    if (mobilePriceDisplay) {
      const priceFormatted = (matchedVariant.price / 100).toFixed(2);
      mobilePriceDisplay.textContent = mobilePriceDisplay.textContent.replace(/[0-9.,\s₹]+/, '₹' + priceFormatted);
    }

    if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
      const compareFormatted = (matchedVariant.compare_at_price / 100).toFixed(2);
      if (buyBoxCompareDisplay) {
        buyBoxCompareDisplay.textContent = '₹' + compareFormatted;
        buyBoxCompareDisplay.style.display = "inline";
      }
      if (mobileCompareDisplay) {
        mobileCompareDisplay.textContent = '₹' + compareFormatted;
        mobileCompareDisplay.style.display = "inline";
      }

      // Calculate and display discount percentage dynamically
      const discountPercent = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
      if (buyBoxDiscountDisplay) {
        buyBoxDiscountDisplay.textContent = `(${discountPercent}% OFF)`;
        buyBoxDiscountDisplay.style.display = "inline";
      }
      if (mobileDiscountDisplay) {
        mobileDiscountDisplay.textContent = `(${discountPercent}% OFF)`;
        mobileDiscountDisplay.style.display = "inline";
      }
    } else {
      if (buyBoxCompareDisplay) buyBoxCompareDisplay.style.display = "none";
      if (mobileCompareDisplay) mobileCompareDisplay.style.display = "none";
      if (buyBoxDiscountDisplay) buyBoxDiscountDisplay.style.display = "none";
      if (mobileDiscountDisplay) mobileDiscountDisplay.style.display = "none";
    }

    if (currentSelectedSize) {
      const activeLabel = document.getElementById("buy-box-active-size-label");
      if (activeLabel) activeLabel.textContent = currentSelectedSize;
      const mobileActiveLabel = document.getElementById("mobile-active-size-label");
      if (mobileActiveLabel) mobileActiveLabel.textContent = currentSelectedSize;
    }
  }

  // Toggle active size badge visibility based on selection
  const mobileSizeBadge = document.querySelector(".mobile-selected-size-badge");
  const buyBoxSizeBadge = document.querySelector(".buy-box-selected-size-badge");
  const mobileChangeSizeBtn = document.querySelector(".mobile-change-size-btn");
  if (mobileSizeBadge && buyBoxSizeBadge) {
    if (sizeChosenOnMobile && currentSelectedSize) {
      mobileSizeBadge.style.display = "inline";
      buyBoxSizeBadge.style.display = "inline";
      if (mobileChangeSizeBtn) mobileChangeSizeBtn.style.display = "inline";
    } else {
      mobileSizeBadge.style.display = "none";
      buyBoxSizeBadge.style.display = "none";
      if (mobileChangeSizeBtn) mobileChangeSizeBtn.style.display = "none";
    }
  }

  if (addToBagBtn && btnText) {
    const allVariantsOutOfStock = variants && variants.length > 0 ? variants.every(v => !v.available) : false;
    
    if (allVariantsOutOfStock) {
      addToBagBtn.setAttribute("disabled", "disabled");
      btnText.textContent = "OUT OF STOCK";
      addToBagBtn.style.opacity = "0.5";
      addToBagBtn.style.pointerEvents = "none";
    } else if (sizeOptionIndex !== -1 && !sizeChosenOnMobile) {
      addToBagBtn.removeAttribute("disabled");
      btnText.textContent = "ADD TO MY BAG";
      addToBagBtn.style.opacity = "1";
      addToBagBtn.style.pointerEvents = "auto";
    } else {
      if (matchedVariant && matchedVariant.available) {
        addToBagBtn.removeAttribute("disabled");
        btnText.textContent = "ADD TO MY BAG";
        addToBagBtn.style.opacity = "1";
        addToBagBtn.style.pointerEvents = "auto";
      } else if (matchedVariant) {
        addToBagBtn.setAttribute("disabled", "disabled");
        btnText.textContent = "OUT OF STOCK";
        addToBagBtn.style.opacity = "0.5";
        addToBagBtn.style.pointerEvents = "none";
      } else {
        addToBagBtn.setAttribute("disabled", "disabled");
        btnText.textContent = "UNAVAILABLE";
        addToBagBtn.style.opacity = "0.5";
        addToBagBtn.style.pointerEvents = "none";
      }
    }
  }
}

// --- 4. SIZE CHART MODAL LOGIC ---
function openSizeChartModal() {
  const modal = document.getElementById("amaniSizeChartModal");
  if (modal) {
    modal.style.display = "flex";
  }
}

function closeSizeChartModal() {
  const modal = document.getElementById("amaniSizeChartModal");
  if (modal) {
    modal.style.display = "none";
  }
}

/**
 * Toggle custom dynamic detail accordions on details-left
 * @param {HTMLElement} btn 
 */
function toggleDetailsAccordion(btn) {
  btn.classList.toggle("active");
  const content = btn.nextElementSibling;
  if (content) {
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  }
}

// --- 3. AMANI BACK-IN-STOCK NOTIFY MODAL INTERACTIVITY ---

function openNotifyModal(size) {
  const modal = document.getElementById("amaniNotifyModal");
  const sizeLabel = document.getElementById("notify-modal-size-label");
  if (modal) {
    if (sizeLabel) sizeLabel.textContent = size;
    modal.style.display = "flex";
  }
}

function closeNotifyModal() {
  const modal = document.getElementById("amaniNotifyModal");
  if (modal) {
    modal.style.display = "none";
  }
}

function handleNotifySubmit(event) {
  event.preventDefault();
  const emailInput = document.getElementById("notify-modal-email");
  const sizeLabel = document.getElementById("notify-modal-size-label");
  if (emailInput && sizeLabel) {
    alert(`Thank you! We will notify ${emailInput.value} as soon as size ${sizeLabel.textContent} is back in stock.`);
    emailInput.value = "";
    closeNotifyModal();
  }
}

// --- 4. MOBILE IMAGE GALLERY VERTICAL SCROLL TRACKING & OVERFLOW CHAINING ---
function initMobileScrollGallery() {
  const gallery = document.querySelector(".product-gallery-grid");
  const indicatorPill = document.querySelector(".mobile-gallery-indicator-pill");

  if (gallery && indicatorPill) {
    function updatePillPosition() {
      if (window.innerWidth > 768) return;
      const scrollHeight = gallery.scrollHeight - gallery.clientHeight;
      if (scrollHeight > 0) {
        const scrollPercent = gallery.scrollTop / scrollHeight;
        const maxTranslateY = 80; // 120px track - 40px pill
        indicatorPill.style.setProperty("transform", `translateY(${scrollPercent * maxTranslateY}px)`, "important");
      }
    }
    gallery.addEventListener("scroll", updatePillPosition, { passive: true });
    gallery.addEventListener("touchmove", updatePillPosition, { passive: true });

    // Enable scroll chaining when reaching boundaries on touch devices (mobile/phone)
    let touchStartY = 0;

    gallery.addEventListener("touchstart", function (e) {
      if (window.innerWidth > 768) return;
      if (e.touches.length === 1) {
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: true });

    gallery.addEventListener("touchmove", function (e) {
      if (window.innerWidth > 768) return;
      if (e.touches.length === 1) {
        const touchCurrentY = e.touches[0].clientY;
        const deltaY = touchStartY - touchCurrentY; // Positive = swiping UP (scrolling page DOWN)
        
        const isAtTop = gallery.scrollTop <= 0;
        const isAtBottom = gallery.scrollTop >= gallery.scrollHeight - gallery.clientHeight - 3;

        if (isAtBottom && deltaY > 0) {
          // Scroll the main page down since we are at the last image and scrolling down
          window.scrollBy(0, deltaY);
          touchStartY = touchCurrentY;
        } else if (isAtTop && deltaY < 0) {
          // Scroll the main page up since we are at the first image and scrolling up
          window.scrollBy(0, deltaY);
          touchStartY = touchCurrentY;
        }
      }
    }, { passive: true });

    // Support wheel/trackpad scrolling chaining as well
    gallery.addEventListener("wheel", function (e) {
      if (window.innerWidth > 768) return;
      const deltaY = e.deltaY;
      const isAtTop = gallery.scrollTop <= 0;
      const isAtBottom = gallery.scrollTop >= gallery.scrollHeight - gallery.clientHeight - 3;

      if (isAtBottom && deltaY > 0) {
        window.scrollBy(0, deltaY);
      } else if (isAtTop && deltaY < 0) {
        window.scrollBy(0, deltaY);
      }
    }, { passive: true });
  }
}

document.addEventListener("DOMContentLoaded", initMobileScrollGallery);
window.addEventListener("load", initMobileScrollGallery);
